/**
 * Manager-facing SentiLink reason copy (PRODUCT-2724).
 * Keep in sync with backend ``providers/sentilink/reason_copy.py``.
 *
 * Existing R001/R002/R004/R008–R011/R013/R016 wording is unchanged.
 */
const SENTILINK_REASON_CODE_DESCRIPTIONS: Readonly<Record<string, string>> = {
  R000: "Name or SSN looks invalid",
  R001: "SSN is randomly issued",
  R002: "SSN may belong to another person",
  R003: "SSN does not match address history",
  R004: "SSN does not align with applicant date of birth",
  R005: "Phone does not match applicant's history",
  R006: "Identity tied to an ITIN",
  R007: "Information matches a deceased individual",
  R008: "SSN tied to a cluster of SSNs used for fraud",
  R009: "Applicant tied to addresses linked to synthetic fraud",
  R010: "Shallow identity history",
  R011: "Credit history inconsistent with claimed age",
  R012: "Identity tied to fraud records",
  R013: "A stronger owner exists for this SSN",
  R014: "Applicant appears to have a different SSN",
  R015: "Weak match to identity records",
  R016: "High application cluster activity on this identity",
  R017: "Linked addresses have risky attributes",
  R018: "Information tied to bankruptcies",
  R019: "Identity has security freezes",
  R020: "SSN may belong to an associate",
  R021: "Risky phone number",
  R022: "Risky email address",
  R023: "Address inconsistent with applicant's history",
  R024: "High application volume at this address",
  R025: "Suspicious application activity on this email",
  R026: "Applicant may not own this email",
  R027: "Information mixed from different people",
  R028: "Unusual activity on linked phones",
  R029: "Applicant may not own this phone",
  R030: "High application activity on this phone",
  R031: "IP address from a risky VPN",
  R032: "IP address does not match address history",
  R033: "Suspicious gap in identity history",
  R034: "Short email history",
  R035: "Suspicious application activity from this IP",
  R036: "Information tied to an associate",
  R037: "IP address from a risky provider",
  R042: "Prior eCBSV failures",
};

const REASON_CODE_IDENTIFIER = /^R\d{3}$/i;
const MORE_FRAUDY_DIRECTION = "more_fraudy";

/** PRODUCT-2724: manager surfaces show only more_fraudy. Missing/unknown direction is hidden. */
export function isSentilinkRiskRaisingDirection(
  direction?: string | null
): boolean {
  return (
    String(direction ?? "")
      .trim()
      .toLowerCase() === MORE_FRAUDY_DIRECTION
  );
}

export function getSentilinkReasonDescription(
  code: string,
  fallbackDescription?: string
): string {
  const mapped =
    SENTILINK_REASON_CODE_DESCRIPTIONS[code] ??
    SENTILINK_REASON_CODE_DESCRIPTIONS[code.toUpperCase()];
  if (mapped) {
    return mapped;
  }
  const fallback = fallbackDescription?.trim() ?? "";
  if (fallback && !REASON_CODE_IDENTIFIER.test(fallback)) {
    return fallback;
  }
  return "";
}

export { SENTILINK_REASON_CODE_DESCRIPTIONS };
